/** Format tier delivery label for public cards */
export function formatDeliveryLabel(tier) {
    if (tier.fulfilled) return 'fulfilled';
    if (tier.estimatedDelivery) return tier.estimatedDelivery;
    return 'none';
}

export function renderTierDeliveryHtml(tier, fund) {
    if (tier.fulfilled) {
        return `<span class="fg-fund-tier-delivery fg-fund-tier-delivery--done">${fund.tr('tierFulfilled')}</span>`;
    }
    if (tier.estimatedDelivery) {
        return `<span class="fg-fund-tier-delivery">${fund.tr('deliveryEst')}: ${tier.estimatedDelivery}</span>`;
    }
    return `<span class="fg-fund-tier-delivery fg-fund-tier-delivery--na">${fund.tr('noDelivery')}</span>`;
}

export function monthYearOptions(selected = '') {
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const year = new Date().getFullYear();
    const opts = [];
    for (let y = year; y <= year + 3; y += 1) {
        months.forEach((m, mi) => {
            const val = `${m} ${y}`;
            opts.push(`<option value="${val}" ${val === selected ? 'selected' : ''}>${val}</option>`);
        });
    }
    return opts.join('');
}

export function getBackersForTier(project, tierId) {
    return (project.comments || []).filter((c) => c.rewardTierId === tierId && c.donorEmail);
}
